import WorkoutEditor from './WorkoutEditor';

export default WorkoutEditor;
